import { LlmChatMessageDto, LlmChatMessageRole, type ToolCallDto } from '@paladin-monorepo/common';
import { getVisibleToolCalls } from './llm-chat-tool-display';

export function hasVisibleToolCalls(message: LlmChatMessageDto): boolean {
  return getVisibleToolCalls(message.toolCalls ?? []).length > 0;
}

export function isToolOnlyAssistantMessage(message: LlmChatMessageDto): boolean {
  return (
    message.role === LlmChatMessageRole.Assistant &&
    !message.content?.trim() &&
    message.attachments.length === 0 &&
    !message.uiAction &&
    hasVisibleToolCalls(message)
  );
}

export function isDisplayableLlmChatMessage(message: LlmChatMessageDto): boolean {
  if (message.role === LlmChatMessageRole.User) return true;
  if (message.role === LlmChatMessageRole.Assistant) {
    return (
      !!(message.content?.trim()) ||
      message.attachments.length > 0 ||
      hasVisibleToolCalls(message) ||
      !!message.uiAction
    );
  }
  return false;
}

export type LlmChatDisplayItem =
  | { type: 'message'; message: LlmChatMessageDto }
  | { type: 'toolSequence'; id: string; toolCalls: ToolCallDto[] };

export function groupLlmChatMessagesForDisplay(messages: LlmChatMessageDto[]): LlmChatDisplayItem[] {
  const items: LlmChatDisplayItem[] = [];

  for (const message of messages.filter(isDisplayableLlmChatMessage)) {
    if (isToolOnlyAssistantMessage(message)) {
      const toolCalls = getVisibleToolCalls(message.toolCalls ?? []);
      const last = items[items.length - 1];
      if (last?.type === 'toolSequence') {
        last.toolCalls.push(...toolCalls);
      } else {
        items.push({ type: 'toolSequence', id: message.id, toolCalls: [...toolCalls] });
      }
      continue;
    }

    items.push({ type: 'message', message });
  }

  return items;
}
